import {store} from '../stores'
import redirect from '../plugins/redirect'

/**
 * This function will check the status of the user that if it's not login by synchronized the data
 * from store.
 */
export const isNotLogin = (to, from, next) => {
  if(!store.state.account.user) {
    return next()
  } else {
    return next({ name: 'Home' })
  }
}

/**
 * This function will check the status of the user that if login by synchronized the data from
 * store.
 */
export const isLogin = (to, from, next) => {
  if (store.state.account.user) {
    return next()
  } else {
    redirect.rememberInitialRoute(to, true, ['ManageAccount'])
    return next({ name: 'Login' })
  }
}

